import { render, staticRenderFns } from "./RightMenu.vue?vue&type=template&id=33446920&scoped=true&"
import script from "./RightMenu.vue?vue&type=script&lang=js&"
export * from "./RightMenu.vue?vue&type=script&lang=js&"
import style0 from "./RightMenu.vue?vue&type=style&index=0&id=33446920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33446920",
  null
  
)

export default component.exports